<div class="conversa chat-redesign"
    (dragenter)="aoArrastarEntrar($event)"
    (dragover)="aoArrastarSobre($event)"
    (dragleave)="aoArrastarSair()"
    (drop)="aoSoltar($event)">
  <app-conversa-cabecalho
    [contato]="contato"
    [carregando]="carregando()"
    [sessaoAberta]="sessaoAberta()"
    [dataFechamento]="dataFechamento()"
    [qtdLembretes]="qtdLembretes()"
    [mostrarVoltar]="mostrarVoltar"
    (voltar)="voltar.emit()"
    (abrirPerfil)="abrirPerfil()"
    (alternarFavorito)="alternarFavorito()"
    (abrirLembretes)="abrirLembretes()"
    (editarContato)="editarContato()"
  ></app-conversa-cabecalho>

  <div class="conversa-area">
    <div class="conversa-corpo">
      <div class="conversa-mensagens" #areaMensagens>
        <div class="conversa-lista" #listaMensagens>
          @if (carregando()) {
            @for (linha of linhasSkeleton; track linha) {
              <div class="conversa-skeleton" [class.conversa-skeleton-sistema]="linha % 2 === 0">
                <div class="skeleton conversa-skeleton-balao" [style.width.%]="linha % 3 === 0 ? 55 : 38"></div>
              </div>
            }
          } @else if (itens().length === 0) {
            @if (!sessaoAberta()) {
              <div class="conversa-vazia">
                <div class="conversa-vazia-icone">
                  <img src="./assets/icones/redesign/modulos/chat/sessao-closed-not-msg.svg" alt="" />
                </div>
                <span class="conversa-vazia-titulo">Sessão não iniciada</span>
                <span class="conversa-vazia-texto">Para iniciar a conversa com o cliente, selecione um template aprovado pela Meta.</span>
              </div>
            } @else {
              <div class="conversa-vazia">
                <div class="conversa-vazia-icone">
                  <img src="./assets/icones/redesign/modulos/chat/components-message/message-square-off.svg" alt="" />
                </div>
                <span class="conversa-vazia-titulo">Nenhuma mensagem ainda</span>
                <span class="conversa-vazia-texto">As mensagens desta conversa vão aparecer aqui.</span>
              </div>
            }
          } @else {
            @if (carregandoMais()) {
              <div class="conversa-skeleton">
                <div class="skeleton conversa-skeleton-balao" style="width: 40%"></div>
              </div>
            }

            @for (item of itensVisiveis(); track item.chave) {
              @if (item.tipo === 'data') {
                <div class="conversa-data"><span>{{ item.label }}</span></div>
              } @else if (item.tipo === 'atendimento') {
                <div class="conversa-evento" [attr.data-chave]="item.chave">
                  <button type="button" class="conversa-evento-card" [title]="item.dica ?? ''"
                          [attr.aria-label]="item.label + ' — ver detalhes'" (click)="abrirDetalhesAtendimento(item.atendimentoId)">
                    <span class="conversa-evento-icone" [class.conversa-evento-icone-inicio]="item.abertura">
                      <img [src]="item.abertura ? './assets/icones/redesign/modulos/chat/components-message/play-atendimento.svg' : './assets/icones/redesign/utils/close-gray.svg'" alt="" />
                    </span>
                    <span class="conversa-evento-texto">{{ item.label }}</span>
                    <span class="conversa-evento-seta">
                      <img src="./assets/icones/redesign/utils/chevron-right.svg" alt="" />
                    </span>
                  </button>
                </div>
              } @else if (item.tipo === 'album') {
                <app-album-imagens
                  class="conversa-balao"
                  [attr.data-chave]="item.chave"
                  [class.conversa-balao-nova]="item.nova"
                  [mensagens]="item.mensagens!"
                  (abrirMidia)="abrirGaleria($event)"
                ></app-album-imagens>
              } @else {
                <app-balao-mensagem
                  class="conversa-balao"
                  [attr.data-chave]="item.chave"
                  [class.conversa-balao-nova]="item.nova"
                  [class.balao-figurinha-aberta]="figurinhaAberta() === item.mensagem"
                  [mensagem]="item.mensagem!"
                  [contato]="contato.numero"
                  [nomeContato]="contato.nome || contato.numero"
                  [fotoContato]="fotoContato"
                  [podeResponder]="sessaoAberta()"
                  (responder)="mensagemResposta.set($event)"
                  (reenviarMensagem)="reenviarMensagem($event)"
                  (abrirMidia)="abrirGaleria($event)"
                  (reagir)="reagirMensagem($event)"
                  (irParaResposta)="irParaMensagem($event)"
                  (audioTerminou)="tocarProximoAudio($event)"
                ></app-balao-mensagem>
              }
            }
          }
        </div>
      </div>

      @if (mostrarBotaoDescer() && !carregando()) {
        <button type="button" class="conversa-btn-descer" @surgir aria-label="Ir para a última mensagem" (click)="descerAoFinal()">
          <img src="./assets/icones/redesign/utils/chevron-bottom-primary.svg" alt="" />
        </button>
      }

      @if (arrastandoArquivo()) {
        <div class="conversa-soltar" @fade>
          <div class="conversa-soltar-caixa">
            <img src="./assets/icones/redesign/modulos/chat/components-message/attach-file.svg" alt="" />
            <span>Solte os arquivos para anexar</span>
          </div>
        </div>
      }
    </div>

    <app-conversa-rodape
      [sessaoAberta]="sessaoAberta()"
      [podeEnviar]="podeEnviar"
      [motivoBloqueio]="motivoBloqueio"
      [bloqueado]="!possuiCanal"
      [ehInstagram]="ehInstagram"
      [carregando]="carregando()"
      [numeroContato]="contato.numero"
      [nomeContato]="contato.nome ?? ''"
      [mensagemResposta]="mensagemResposta()"
      (enviarTexto)="enviarTexto($event)"
      (enviarArquivos)="enviarArquivos($event)"
      (cancelarResposta)="mensagemResposta.set(undefined)"
      (abrirTemplates)="selecaoTemplateAberta.set(true)"
    ></app-conversa-rodape>

    @if (selecaoTemplateAberta() && !sessaoAberta() && !ehInstagram) {
      <app-selecao-template
        [numeroContato]="contato.numero"
        [nomeContato]="contato.nome ?? ''"
        (fechar)="selecaoTemplateAberta.set(false)"
        (enviado)="aoEnviarTemplate($event)"
      ></app-selecao-template>
    }
  </div>
</div>
